module.exports = "https://s91588.cdn.ngenix.net/home-frontend/_next/static/images/credit_2x-03fde9bd2d95d27d64b7c592e14a6cf7.webp";